let prod = true;


const config = {
    url: prod ? "https://www.strasbourg.port.fr/payfip.php" : "http://localhost/pass",
    params: {
        refdet: "",
        montant: 0,
        mel: "",
    }
}

export default config;